import * as Yup from "yup";
import { websiteUrlRegex } from "../../../constants/regexStrings";
import phoneValidation from "../../../common/components/phone-number-input-component/phone-validation";
import { isOnlyCountryCode } from "../../../utils/utils";

const dynamicFieldValidationSchema: Record<string, Yup.AnySchema> = {
    company: Yup.string().required("Company cannot be empty").max(150, "Company cannot be more than 150 characters"),
    website: Yup.string().required("Website cannot be empty").matches(websiteUrlRegex, "Enter a valid website URL").nullable().max(150, "Website cannot be more than 150 characters"),
    leadSource: Yup.string().required("Lead Source cannot be empty"),
    leadStatus: Yup.string().required("Lead Status cannot be empty"),
    faxNumber: Yup.string()
        .required('Fax cannot be empty')
        .test("is-valid-fax", "Please enter a valid fax number", (value) => {
            // Skip validation only if the string is not empty
            if (value && isOnlyCountryCode(value)) {
                return true;
            }
            return value ? phoneValidation(value) : true;
    }),
    industry: Yup.string().required("Industry cannot be empty").max(50, "Industry cannot be more than 50 characters").nullable(),
    numberOfEmployees: Yup.number()
        .transform((value, originalValue) => {
            return originalValue === '' ? null : value;
        })
        .nullable()
        .required("Number of employees cannot be empty")
        .typeError("Number of employees must be a number")
        .min(1, "Number of employees must be greater than 0")
        .max(9999999, "Number of employees must be less than or equal to 9999999"),
    annualRevenue: Yup.number()
        .transform((value, originalValue) => {
            return originalValue === '' ? null : value;
        })
        .nullable()
        .required("Lead value cannot be empty")
        .typeError("Lead value must be a number")
        .min(1, "Lead value must be greater than 0"),
    interestedProducts: Yup.string().required("Interested Products cannot be empty").nullable(),
    rating: Yup.string().required("Confidence Score cannot be empty").nullable(),
    socialLeadId: Yup.string().required("Social Lead Id cannot be empty").matches(websiteUrlRegex, "Invalid Social Lead ID").max(50,"Social Lead Id cannot be more than 50 characters").nullable(),
    description: Yup.string().required("Description cannot be empty").max(150, "Description cannot be more than 150 characters").nullable(),
    leadOwner: Yup.string().required("Lead Owner is required"),
    leadValue: Yup.number()
        .transform((value, originalValue) => originalValue === "" ? undefined : value)
        .required("Lead Value cannot be empty")

};

export default dynamicFieldValidationSchema;
